import { styled } from '@mui/material';

const PREFIX = 'Account';

export const classes = {
  root: `${PREFIX}-root`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(4),
  },
}));